import type { FaireProductEntity } from "../../entity_types/product";

export const p_cuu8tznq7u: FaireProductEntity = {
  token: "p_cuu8tznq7u",
  type: "product",
  name: "rocky's matcha Uji Premium Ceremonial Blend 1kg",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/230167aa2da78833a67bd03530415352177c22e38e284e0bcebdb270072cfd25.jpeg",
  galleryImageUrls: [],
  priceDollars: 450,
  description: "rocky's matcha Uji Premium Ceremonial Blend is a luxurious single-origin matcha from Uji, Japan crafted exclusively from carefully selected first-harvest tea leaves. Its creamy, elegant flavor profile features a subtle nuttiness, harmonized with balanced umami and a gentle astringency. Perfectly versatile, this matcha pairs beautifully with milk for lattes or shines on its own as usucha, making it an excellent choice for various beverage creations.\n\n• Blended Matcha\n\n• Ceremonial Grade\n\n• Net Weight: 1kg",
  tags: [],
  msrpDollars: 900,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:20.715Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
